import React, { useState } from "react";

import { string, func, object, bool, shape } from "prop-types";

import { Button, Loading } from "../../../common";

import { isEmpty } from "../../../helpers";

import { DOB } from "..";

import DateError from "../NamesAndDOB/DateError";

import ContactTelephone from "../Contacts/ContactTelephone";

import * as style from "./styles.module.scss";
import OnboardImage from "../../OnboardImage";

const BasicInfoName = ({
  firstName,
  birthDay,
  birthMonth,
  birthYear,
  homeTelephone,
  mobileTelephone,
  onTelephoneChange,
  itemsChanged,
  onChange,
  validation,
  onSubmit,
  loading,
}) => {
  const is16yo = (day, month, year) => {
    const today = new Date();
    const birthDate = new Date(year, month, day);
    const age = today.getFullYear() - birthDate.getFullYear();
    const isBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate());

    const actualAge = isBirthdayPassed ? age : age - 1;
    return actualAge >= 16;
  };

  const isValid = (item) =>
    !itemsChanged[item] || validation[item] === undefined;

  const hasValidContactNumber =
    !isEmpty(mobileTelephone) && isValid("mobileTelephone");
  const hasInvalidItem = ["mobileTelephone"]
    .map((item) => isValid(item))
    .includes(false);

  const hasValidDob =
    !isEmpty(birthDay) &&
    !isEmpty(birthMonth) &&
    !isEmpty(birthYear) &&
    is16yo(birthDay, birthMonth, birthYear);

  const formInputs = {
    birthDay,
    birthMonth,
    birthYear,
    homeTelephone,
    mobileTelephone,
  };

  const [isFormTouched, setFormTouched] = useState(false);
  (() =>
    !isFormTouched &&
    Object.values(formInputs).filter((_formElem) => !!_formElem === true)
      .length &&
    !(!!hasInvalidItem || loading) &&
    setFormTouched(true))();

  const dobNotFull = birthDay === "" || birthMonth === "" || birthYear === "";
  const isDobInvalid = !is16yo(birthDay, birthMonth, birthYear);

  const dobValidationMessage = dobNotFull
    ? "Please enter a date of birth"
    : "You must be 16 years old and above to register";

  return (
    <div className="row h-100">
      <OnboardImage
        title={`Welcome ${firstName}!`}
        subtitle="Let's get your account set up"
        desktopDescription="The more you complete the easier it is to help you find work."
        mobileDescription="The more you complete the easier it is to help you find work."
        imagePath="/images/basic_info.svg"
        className={style.basicInfo__imageBackground}
        imageClassName={style.basicInfo__image}
      />
      <div className={`col-sm-12 col-lg-6 mt-2 ${style.basicInfo__form}`}>
        <div className="row">
          <DOB
            dayOfBirth={birthDay}
            monthOfBirth={birthMonth}
            yearOfBirth={birthYear}
            handleChange={onChange}
            validation={validation}
            isInvalid={isDobInvalid}
          />
          {isDobInvalid && <DateError errorMessage={dobValidationMessage} />}
        </div>
        <div className="row mt-2">
          <div className="col-12">
            <ContactTelephone
              inputId="mobileTelephone"
              inputName="mobileTelephone"
              title="Mobile*"
              number={mobileTelephone}
              handleChange={onTelephoneChange}
              valueName="mobileTelephone"
              validation={
                itemsChanged.mobileTelephone
                  ? validation.mobileTelephone
                  : undefined
              }
            />
          </div>
        </div>
        <div className={`mt-lg-auto my-2 mb-lg-0 ${style.basicInfo__actions}`}>
          <Button
            classes="btn btn-primary btn-block"
            onClick={onSubmit}
            disabled={
              !isFormTouched ||
              !hasValidDob ||
              !hasValidContactNumber ||
              Object.keys(validation).length !== 0
            }
          >
            {loading ? <Loading /> : "Next"}
          </Button>
        </div>
      </div>
    </div>
  );
};

BasicInfoName.propTypes = {
  title: string.isRequired,
  firstName: string.isRequired,
  lastName: string.isRequired,
  birthDay: string.isRequired,
  birthMonth: string.isRequired,
  birthYear: string.isRequired,
  onChange: func.isRequired,
  onSubmit: func.isRequired,
  isChanged: bool.isRequired,
  validation: object.isRequired,
  description: string.isRequired,
  itemsChanged: shape({
    homeTelephone: bool,
    mobileTelephone: bool,
  }).isRequired,
  loading: bool.isRequired,
  route: string.isRequired,
  homeTelephone: string.isRequired,
  mobileTelephone: string.isRequired,
  onTelephoneChange: func.isRequired,
};

export default BasicInfoName;
